module.exports = __webpack_public_path__ + "h5/img/组 4.a1fa8c09.png";